import { Messages } from '../../../../codegen/Localize';
import { ISubscriptionInfo } from '../../../../ts/models/ISubscriptionInfo';
import { changeSubscriptionDataCondition } from '../../../actions/spaces/SubscriptionsActions';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const ChangeSubscriptionDataConditionEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: EntityActionNames.SubscriptionChangeDataSetting,
  translateName: Messages.changeSubscriptionDataCondition_action,
  isVisible: () => true,
  isClickable: (availableActions: {}, subscriptions: ISubscriptionInfo[]) => {

    if(subscriptions.length > 1) { // We do not allow action for multiple items
      return false;
    }

    return subscriptions[0].canManageSubscription && subscriptions[0].canSpecifyDataCondition;
  },
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => changeSubscriptionDataCondition(subscriptions[0])
};
